import { render, staticRenderFns } from "./PageLogin.vue?vue&type=template&id=845ef128&scoped=true&"
import script from "./PageLogin.vue?vue&type=script&lang=ts&"
export * from "./PageLogin.vue?vue&type=script&lang=ts&"
import style0 from "./PageLogin.vue?vue&type=style&index=0&id=845ef128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845ef128",
  null
  
)

export default component.exports